import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { Urls } from "../../../../../Urls";
import { ButtonLabels } from "../../../AddClient/Resource/Contents";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { Review } from "./Review";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { QuoteToApplyInstructionClient } from "../../../../../../../Wrap/Api/Apply/QuoteToApplyInstruction";
import { ApplyModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { HierarchyLevelName } from "../../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { HierarchyIdHelper } from "../../../../../../Shared/Common/HierarchyIdHelper";

interface IQuoteReadyProps extends IProcessComponentProps {}

interface IQuoteReadyState {
    isOpen: boolean;
    isLoading: boolean;
}

export class QuoteReady extends ProcessComponent<IQuoteReadyProps, IQuoteReadyState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isOpen: false,
            isLoading: false,
        };
    }

    private startNewBusiness() {
        const quoteToApply = new QuoteToApplyInstructionClient();
        const promise = quoteToApply.put(this.props.data);
        promise
            .onSuccess((result: ApplyModel) => {
                Navigator.navigateTo(Urls.get().FullClientDetail, {
                    scrollAfterNavigating: true,
                    queryParamsObject: {
                        customerid: getQueryParameters()["customerid"],
                        id: result.AccountRoleInstructionId,
                        quoteid: result.QuoteId,
                    },
                });
            })
            .onError((error) => {
                console.log(error);
            });
    }

    public render(): JSX.Element {
        const { isLoading } = this.state;
        if (isLoading) {
            return <PartLoading isLoading={isLoading}></PartLoading>;
        }
        return (
            <>
                <div>
                    <Review {...this.props}></Review>
                    <div className="page-actions no-print">
                        <div className="action-secondary">
                            <button
                                onClick={() => {
                                    Navigator.navigateTo(
                                        Urls.get().main.PortfolioDashboard({
                                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(
                                                HierarchyLevelName.Customer,
                                                getQueryParameters()["customerid"]
                                            ),
                                        }).activity
                                    );
                                }}
                                className="prev-button"
                            >
                                <span aria-hidden="true" className="icon"></span>
                                <span className="text">{ButtonLabels.backToDashboard}</span>
                            </button>
                        </div>

                        <div className="action-secondary">
                            <button
                                onClick={() => {
                                    window.print();
                                }}
                                className="print-button"
                            >
                                <span aria-hidden="false" className="print-icon"></span>
                                {ButtonLabels.printReview}
                            </button>
                        </div>

                        <div className="action-primary">
                            <div
                                className="primary-dropdown"
                                onClick={() =>
                                    this.updateStatePart((x) => {
                                        x.isOpen = !this.state.isOpen;
                                    })
                                }
                            >
                                <button className="trigger" aria-expanded={this.state.isOpen} aria-haspopup="true">
                                    <span className="text">{ButtonLabels.nextLabel}</span>
                                    <span className="icon" aria-hidden="true"></span>
                                </button>
                                {this.state.isOpen && (
                                    <div className="dropdown-list a-dropdown-enter-done">
                                        <div className="dropdown-list-panel">
                                            <div
                                                className="item"
                                                onClick={() =>
                                                    (window.location.href =
                                                        Urls.get().QuoteWrapperSelection.getUrl() +
                                                        "?customerid=" +
                                                        getQueryParameters()["customerid"])
                                                }
                                            >
                                                {ButtonLabels.quote}
                                            </div>
                                            <div className="item" onClick={() => this.startNewBusiness()}>
                                                {ButtonLabels.newBusiness}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
